import { useState, useEffect, useCallback } from 'preact/hooks';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';
import { listDevices, logout, nsecLogin, getStoredNsec } from './lib/api';
import { forgetLocalIdentity } from './lib/nostr';

type AuthState = 'checking' | 'anonymous' | 'authenticated';

export function App() {
  const [auth, setAuth] = useState<AuthState>('checking');

  const checkSession = useCallback(async () => {
    try {
      await listDevices();
      setAuth('authenticated');
    } catch {
      const storedNsec = getStoredNsec();
      if (storedNsec) {
        try {
          await nsecLogin(storedNsec);
          setAuth('authenticated');
          return;
        } catch {}
      }
      setAuth('anonymous');
    }
  }, []);

  useEffect(() => {
    void checkSession();
  }, [checkSession]);

  const handleAuthenticated = useCallback(() => {
    setAuth('authenticated');
  }, []);

  const handleLogout = useCallback(async () => {
    try {
      await logout();
    } catch {
      /* cookie may already be gone; proceed regardless */
    }
    forgetLocalIdentity();
    setAuth('anonymous');
  }, []);

  if (auth === 'checking') {
    return (
      <div class="card">
        <p class="muted">Loading…</p>
      </div>
    );
  }

  if (auth === 'anonymous') {
    return <Login onAuthenticated={handleAuthenticated} />;
  }

  return <Dashboard onLogout={handleLogout} />;
}
